"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNoAncestorBindingConstraintsWithTag = isNoAncestorBindingConstraintsWithTag;
const isBindingConstraintsWithTag_1 = require("./isBindingConstraintsWithTag");
const isNoAncestorBindingConstraints_1 = require("./isNoAncestorBindingConstraints");
function isNoAncestorBindingConstraintsWithTag(tag, value) {
    return (0, isNoAncestorBindingConstraints_1.isNoAncestorBindingConstraints)((0, isBindingConstraintsWithTag_1.isBindingConstraintsWithTag)(tag, value));
}
//# sourceMappingURL=isNoAncestorBindingConstraintsWithTag.js.map